// extracted by mini-css-extract-plugin
export var deleteModal = "_ru-0";